import { EFullscreenGalleryActionTypes } from '../../actions/fullscreenGallery';
import { IFullscreenGalleryState } from '../../types/fullscreenGallery';
import { TReduxActions } from '../../types/redux';

export const INITIAL_GALLERY_STATE: IFullscreenGalleryState = {
  isOpen: false,
};

export function fullscreenGalleryReducer(
  state: IFullscreenGalleryState = INITIAL_GALLERY_STATE,
  action: TReduxActions,
): IFullscreenGalleryState {
  switch (action.type) {
    case EFullscreenGalleryActionTypes.CloseGallery:
      return {
        ...state,
        isOpen: false,
        slideIndex: undefined,
        dateSlideIndex: undefined,
      };

    case EFullscreenGalleryActionTypes.OpenGallery: {
      const { payload } = action;

      return {
        ...state,
        isOpen: true,
        slideIndex: payload.slideIndex,
        dateSlideIndex: payload.dateSlideIndex,
      };
    }
    default:
      return state;
  }
}
